import type {
  GetEnrollmentResponse,
  PaginatedResultOfGetEnrollmentResponse,
} from "@/openapi/generated";
import { occupiesClassSpot } from "@/lib/utils/enrollment";

export type StudentEnrolledClassOption = {
  value: string;
  label: string;
  classId: number;
};

export function normalizeEnrollmentsList(
  data:
    | GetEnrollmentResponse[]
    | PaginatedResultOfGetEnrollmentResponse
    | undefined
    | null,
): GetEnrollmentResponse[] {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  return data.items ?? [];
}

export function getStudentEnrolledClassOptions(
  enrollments: GetEnrollmentResponse[] | undefined | null,
): StudentEnrolledClassOption[] {
  const byClassId = new Map<number, StudentEnrolledClassOption>();

  for (const enrollment of enrollments ?? []) {
    if (!occupiesClassSpot(enrollment)) continue;

    const classId = Number(enrollment._class?.classId);
    if (!Number.isFinite(classId)) continue;

    const name = enrollment._class?.name?.trim();
    byClassId.set(classId, {
      classId,
      value: String(classId),
      label: name || `Class #${classId}`,
    });
  }

  return [...byClassId.values()].sort((a, b) => a.label.localeCompare(b.label));
}

export function getStudentEnrolledClassSelectOptions(
  enrollments: GetEnrollmentResponse[] | undefined | null,
  options?: { includeNone?: boolean },
): Array<{ value: string; label: string }> {
  const classOptions = getStudentEnrolledClassOptions(enrollments).map(
    ({ value, label }) => ({ value, label }),
  );

  if (options?.includeNone) {
    return [{ label: "None", value: "" }, ...classOptions];
  }

  return classOptions;
}
